import { Gender } from "./base-user.interface";

export interface IOrder {
  id: string;
  study: IStudy;
  subject: IStudySubject;
}

export interface IStudy {
  id: string;
  name: string;
}
export interface IStudySubject {
  id?: string;
  gender?: Gender;
  yearOfBirth?: number;
  nextVisitId?: string;
  order?: ISubjectOrderDetails;
  otherStudy?: IOtherStudy;
  orderStatus?: OrderStatus;
}

export interface ISubjectOrderDetails {
  number?: string;
  isCancelable?: boolean;
  visitId?: string;
}

export interface IOtherStudy {
  isExists: boolean;
  name: string;
}

export enum OrderStatus {
  Unknown,
  NewOrderNewSubject,
  NewOrderExistingSubject,
  OpenOrderCancelable,
  OpenOrderNotCancelable,
}

export type OrderFormDetails = {
  study: string;
  subjectId: string;
  retypeSubjectId: string;
  gender: Gender;
  yearOfBirth: string;
  visitId: string;
};

export interface CreatedOrderDetails {
  orderNumber: string;
  studyName: string;
  subjectId: string;
  createdDetails: EditOrderDetails;
}
export interface CanceledOrderDetails {
  orderNumber: string;
  studyName: string;
  subjectId: string;
  createdDetails: EditOrderDetails;
  canceledDetails: EditOrderDetails;
}

export interface EditOrderDetails {
  userId?: string;
  salutation?: string;
  firstName?: string;
  lastName?: string;
  date?: string;
}
